import { getApiBaseUrl, withProjectPath } from 'services/projectContext';

export const SocketType = {
    USER_SUPPORT: 'USER_SUPPORT_SOCKET',
    NOTIFICATION: 'NOTIFICATION_SOCKET',
};

export const SocketURLMap = {
    [SocketType.USER_SUPPORT]: '/user-support/admin/conversations',
    [SocketType.NOTIFICATION]: '/notifications',
};

export const getSocketURL = (socketType) =>
    `${getApiBaseUrl().replace('http', 'ws')}${withProjectPath(SocketURLMap[socketType])}`;

export const wsConnect = ({ socketType }) => ({
    type: 'WS_CONNECT',
    socketType,
});
export const wsEnsureConnected = ({ socketType }) => ({
    type: 'WS_ENSURE_CONNECTED',
    socketType,
});
export const wsDisconnect = (socketType, host) => ({ type: 'WS_DISCONNECT', socketType, host });
export const wsSend = ({ socketType, messageType, message }) => ({
    type: 'WS_SEND',
    socketType,
    messageType,
    message,
});
